<template>
  <NuxtLink v-slot="{ href, navigate }" v-bind="$attrs" custom>
    <a
      :class="linkClass"
      :href="href"
      :title="title"
      @click="onNavigate($event, navigate)"
      @click.right="onNavigate($event, navigate)"
      @click.middle="onNavigate($event, navigate)"
    >
      <slot />
    </a>
  </NuxtLink>
</template>

<script lang="ts">
import Vue from 'vue';
import warRoomSignUpMixin from '~/components/partials/war-room/WarRoomSignUp/warRoomSignUpMixin';

// TODO: better to remove link from that component and intercept click
//       instead of
export default Vue.extend({
  name: 'SignUpWallLink',
  mixins: [warRoomSignUpMixin],
  inheritAttrs: false,
  props: {
    linkClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
  },
  methods: {
    onNavigate(event: MouseEvent, navigate: (e: MouseEvent) => void) {
      if (this.$auth.loggedIn) {
        navigate(event);
      } else {
        event.preventDefault();
        // @ts-ignore, method comes from mixin
        this.openWarRoomSignUpModal();
      }
    },
  },
});
</script>
